import React from "react";
import EventsListPage from "./EventsListPage";
import { Camera, PlayCircle, Trophy } from "lucide-react";

const EventGalleries = ({ presentEvents = [], pastEvents = [] }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <Camera className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Event{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Galleries</span>
            </span>
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Pick an event to browse its photos - from tournaments happening
            now to memorable moments from RGCC's history
          </p>
        </div>
      </div>

      {/* Present Events */}
      <div className="pt-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center gap-3 mb-2">
          <PlayCircle className="w-6 h-6 text-emerald-600" />
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Present Events
          </h2>
        </div>
        <EventsListPage events={presentEvents} title="Present Events" />
      </div>

      {/* Past Events */}
      <div>
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center gap-3 mb-2">
          <Trophy className="w-6 h-6 text-amber-600" />
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Past Events
          </h2>
        </div>
        <EventsListPage events={pastEvents} title="Past Events" />
      </div>
    </div>
  );
};

export default EventGalleries;
